<template>
  <div class="pagination-container">
    <div class="many-pages-holder pages-block-container" v-if="tempPage2() > 4">
      <div
        class="pageNumberBlock"
        @click="localSetPageNumber(1)"
        :class="{ pageNumberBlockActive: pageNumber === 1 }"
      >
        1
      </div>
      <div
        class="pageNumberBlock"
        @click="localSetPageNumber(2)"
        :class="{ pageNumberBlockActive: pageNumber === 2 }"
      >
        2
      </div>
      <div
        class="pageNumberBlock"
        @click="localSetPageNumber(3)"
        :class="{ pageNumberBlockActive: pageNumber === 3 }"
      >
        3
      </div>
      <div
        class="pageNumberBlock"
        @click="localSetPageNumber(4)"
        :class="{ pageNumberBlockActive: pageNumber === 4 }"
      >
        4
      </div>
      <div
        :class="{
          pageNumberBlockActive: pageNumber > 4,
          pageNumberBlock: true,
          pageNumberSelector: pageInput === true,
        }"
        @click="openPageNumberInput(true)"
      >
        <input
          placeholder="#"
          :class="{
            pageNumberInputActive: pageInput === true,
            pageNumberInput: pageInput === false,
          }"
          v-on:keyup.enter="localSetPageNumber()"
          autofocus
        />
        <span v-if="pageNumber <= 4 && !pageInput">...</span>
        <span v-if="pageNumber > 4 && !pageInput">{{ pageNumber }}</span>
      </div>
      <div
        class="pageNumberBlock"
        @click="localSetPageNumber(calculatePages())"
        :class="{ pageNumberBlockActive: pageNumber === this.calculatePages() }"
      >
        {{ this.calculatePages() }}
      </div>
    </div>
    <div class="few-pages-holder pages-block-container" v-else>
      <div
        class="pageNumberBlock"
        v-for="block in this.calculatePages()"
        :key="block"
        :class="{ pageNumberBlockActive: pageNumber === block }"
        @click="localSetPageNumber(block)"
      >
        {{ block }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  //Just put the input field right in the buttont that says "..."
  data() {
    return {
      pageInput: false,
    };
  },
  props: {
    calculatePages: { type: Function },
    setPageNumber: { type: Function },
    pageNumber: { type: Number },
  },

  methods: {
    tempPage2() {
      return this.calculatePages();
    },
    openPageNumberInput(boolean) {
      this.pageInput = boolean;
    },

    localSetPageNumber(page) {
      if (page) {
        this.pageInput = false;
        this.setPageNumber(page);
        document.querySelector(".pageNumberInputActive").value = "";
      } else {
        let newPageNumber = document.querySelector(".pageNumberInputActive")
          .value;
        this.setPageNumber(newPageNumber);
      }
    },
  },
};
</script>
<style>
.pagination-container {
}

.pages-block-container {
  position: relative;
  display: flex;
  justify-content: space-between;

  width: 100%;
}

.pages-block-container-focus {
  position: relative;
  display: flex;
  justify-content: space-between;

  width: 100%;
}

.pageNumberBlock {
  positon: relative;
  background-color: white;

  box-shadow: 0px 0px 2px 2px rgba(189, 195, 199, 0.7);
  padding: 5px 8px;
  border-radius: 3px;
  max-width: 60px;

  transition: 0.3s;
}

.pageNumberBlock:hover {
  background-color: gray;
  cursor: pointer;
}

.pageNumberSelector {
  transition: 0.3s;
}

.pageNumberBlockActive {
  background-color: #ef6c00;
  color: white;
  transition: 0.3s;
}

.pageNumberInput {
  display: none;
}

.pageNumberInputActive {
  position: relative;
  display: inline-block;
  outline: none;
  width: 100%;
  color: black;
  transition: 0.3s;
}

.pageInputActive {
  position: absolute;
  left: 0px;
  bottom: 100%;
  background-color: red;
  border-radius: 3px;
  width: 200px;
  height: 150px;
  box-shadow: 0px 0px 2px 2px gray;

  transition: 0.3s;
}

.pageInputDefault {
  display: none;
}

.few-pages-holder {
  display: inline-block;
}

.few-pages-holder .pageNumberBlock {
  margin-right: 12px;
  display: inline-block;
}
</style>
